import PermissionDecoderInterface from '@/utilities/auth/permission/decoder/interfaces/PermissionDecoderInterface'
import { PermissionRules } from '@/utilities/auth/permission/enums/PermissionEnum'

export default class PermissionDecoder implements PermissionDecoderInterface {
  protected permissionLevel: number

  constructor(permissionLevel: number) {
    this.permissionLevel = permissionLevel
  }

  convertToBinary(): boolean[] {
    return this.permissionLevel
      .toString(2)
      .padStart(Object.keys(PermissionRules).length, '0')
      .split('')
      .map(v => Boolean(+v))
      .reverse()
  }

  decode() {
    const rules = this.convertToBinary()

    const permissionsRules = Object.keys(PermissionRules).map((permission, index) => [permission, rules[index]])

    return Object.fromEntries(permissionsRules)
  }
}
